import * as fromDatatype from '../datatype-library';

export interface bl_wf_md_transition_role_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  transition_guid: fromDatatype.GuidDataFieldInterface;
  role_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wf_md_transition_role_link_RowClass
  implements bl_wf_md_transition_role_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    transition_guid: fromDatatype.GuidDataFieldInterface;
    role_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
